import { render, staticRenderFns } from "./FullyAutomated.vue?vue&type=template&id=04b8864f&scoped=true"
import script from "./FullyAutomated.vue?vue&type=script&lang=js"
export * from "./FullyAutomated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b8864f",
  null
  
)

export default component.exports